class Blog {
	constructor(request) {
		this.request = request
		this.endpoint = 'blog'
	}

    GetBlogs(type) {
        return this.request.requestData(
            `https://cdn.ngnw.ph/lists/${this.endpoint}/${type}.json`
        )
    }

    GetBlog(url) {
        return this.request.requestData(
            `https://cdn.ngnw.ph/details/${this.endpoint}/${url}.json`
        )
    }
}

export default Blog;